import { IAppState } from 'spw-redux/reducer';

export const selectTeamsList = (state: IAppState) => state.teamsReducer.list;

export const selectTeam = (state: IAppState) => state.teamsReducer.team;

export const selectIsTeamLoading = (state: IAppState) =>
  state.teamsReducer.loading;

export const selectTeamsForProjectList = (state: IAppState) =>
  state.teamsReducer.teamsForProjectList;

export const selectProjectsForTeamList = (state: IAppState) =>
  state.teamsReducer.projectsForTeamList;

export const selectTeamMembersForTeamList = (state: IAppState) =>
  state.teamsReducer.teamMembersForTeamList;

export const selectTeamsForPopoverList = (state: IAppState) =>
  state.teamsReducer.teamsForPopoverList;
